import { useQuery } from '@tanstack/react-query';

import getHomePlannings, { ResGetHomePlannings } from '@/service/market/planning/getHomePlannings';
import { RQPlanningKey } from './RQPlanningKey';

const useHomePlanningsQuery = () => {
  return useQuery<
    ResGetHomePlannings,
    object,
    ResGetHomePlannings['result'],
    (typeof RQPlanningKey)['planningHomeProducts']
  >({
    queryKey: RQPlanningKey['planningHomeProducts'],
    queryFn: () => getHomePlannings({}),
    select: (data) => {
      return data.result;
    },
    staleTime: Infinity,
    gcTime: Infinity,
  });
};

export default useHomePlanningsQuery;
